import { LitElement, html } from 'lit-element';

class OccupancyLayer extends LitElement {
    static get properties() {
        return {
            id: {type: String},
            settings: { type: Object },
            occupancy: {
                type: Object,
                reflect: true
            },
            occupancyCopy: {
                type: Object
            },
            passengers: {type: Number, reflect: true},
            totalAdults: {type: Number},
            totalChildren: {type: Number},
            rooms: {type: Number, reflect: true},
            childrenAges: {type: Array}
        }
    }

    constructor() {
        super();
        // Initialize properties
        this.settings = {
            "rooms":{
                "min":1,
                "max":4,
                "rooms_max_diff":3,
                "def": 0
            },
            "adults":{
                "min":2,
                "max":9,
                "def":1
            },
            "children":{
                "min":0,
                "max":9,
                "babies_max":9,
                "def":0
            },
            "ages":{
                "min":2,
                "max":13,
                "less":true,
                "def":0
            },
            "errors":{
                "babies":"La combinación de viajeros no está permitida. Para hacer la reserva póngase en contacto con nosotros.",
                "rooms":"La combinación de viajeros no está permitida. Para hacer la reserva póngase en contacto con nosotros.",
                "ages":"Debes indicar la edad de los niños",
                "max_passenger":"La combinación de viajeros no está permitida",
                "max_room_occupants":"La combinación de viajeros no está permitida. Para hacer la reserva póngase en contacto con nosotros",
                "children_per_adult":"La combinación de pasajeros no está permitida. No puede haber más del doble de niños que de adultos en una misma reserva.",
                "babies_per_adult":"No es posible realizar una reserva con más de un bebé por cada adulto.",
                "invalid_occupancy":"La combinación de viajeros no está permitida.Para hacer la reserva póngase en contacto con nosotros."
            },
            "labels":{
                "rooms_text":"Habitaciones",
                "room_text":"Habitación",
                "adults_text":"Adultos",
                "children_text":"Niños",
                "person_text":"Persona",
                "people_text":"Personas",
                "children_age_text":"Edad",
                "ages_text":"años",
                "childs_age_text":"Niño",
                "child_age_label":"Edad niño",
                "children_age_label":"Edad niños",
                "close_layer_text":"Cerrar",
                "done_layer_text":"Hecho",
                "delete_room_text":"Eliminar",
                "add_room_text":"Añadir habitación",
                "no_chidren_text":"¿Viajas con niños? Contáctanos y te ayudaremos."
            },
            "cookie":"transport_flight",
            "max_passengers":9,
            "max_room_occupants":0,
            "children_per_adult":2,
            "babies_per_adult":1,
            "invalid_occupancies":{},
            "newSearcher":true
        };
        this.occupancy = [{"adults":2,"children":0,"ages":[]}];
        this.occupancyCopy = [];
        this.passengers = 2;
        this.totalAdults = 2;
        this.totalChildren = 0;
        this.rooms = 0;
        this.childrenAges = [];
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this.totalAdults = this._countAdults();
        this.totalChildren = this._countChildren();
        this.passengers = this._countPassengers();
        this.rooms = this.settings.rooms.def;
    }
    updated(changedProperties){
        if (changedProperties.has('rooms')) {
            this._checkRooms();
            this._focusRooms();
        }
        if (changedProperties.has('occupancy')) {
            this._validateAges();
            this._focusAges();
        }

        this.totalAdults = this._countAdults();
        this.totalChildren = this._countChildren();
        this.passengers = this._countPassengers();
    }
    _toggleMenu() {
        let self = this;
        let menu = self.querySelector('.searchDropdown');
        menu.classList.add('transitioning');
        setTimeout(function() {
            self.querySelector('.searchDropdown').classList.remove('transitioning');
            self.querySelector('.searchDropdown').classList.toggle('hidden');
            if(self.querySelector('.searchDropdown').classList.contains("hidden")) {
                self.querySelector(".searchToggle__btn").setAttribute('aria-expanded', 'false');
            } else {
                self._evalDirectionDrop();
                self.querySelector(".searchToggle__btn").setAttribute('aria-expanded', 'true');
            }
            document.body.classList.toggle('sm-no-scroll');
        }, 10);
    }
    _saveChangesAndToggle(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this._validateAges()) {
            this.occupancyCopy = JSON.parse(JSON.stringify(this.occupancy));
            this._countRooms();
            this._toggleMenu();
        }
    }
    _evalDirectionDrop() {
        let self = this;
        var dropElement = self.querySelector('.searchDropdown');
        var dropBt = self.querySelector('.searchToggle__btn');
        var siteHeader = document.querySelector('header');
        var siteHeaderHeight = 0;
        if (siteHeader) {
            siteHeaderHeight = siteHeader.offsetHeight;
        }
        var windowHeight = window.innerHeight;
        var windowPageYOffset = window.pageYOffset;
        var remainingSiteHeaderHeight = 0;
        if (windowPageYOffset <= siteHeaderHeight) {
            remainingSiteHeaderHeight = siteHeaderHeight - windowPageYOffset;
        } else {
            remainingSiteHeaderHeight = 0;
        }
        dropElement.classList.remove("searchDropup");
        var topPos = dropElement.getBoundingClientRect().top + window.pageYOffset;
        // solo se evalua si abrir para arriba si rooms 0 (solo vuelo) o si en hotel solo hay una habitacion
        if (this.rooms <= 1) {
            // solo se abre hacia arriba si la altura del selector es mayor que el espacio que le queda por debajo a la pantalla y la altura del elemento cabe
            if( (topPos + dropElement.offsetHeight) > (windowHeight + windowPageYOffset) && (dropElement.offsetHeight) < (dropElement.getBoundingClientRect().top - dropBt.offsetHeight - remainingSiteHeaderHeight)) {
                dropElement.classList.add("searchDropup");
            } else {
                dropElement.classList.remove("searchDropup");
            }
        }
    }
    _validateAges() {
        let self = this;
        let isValid = true;
        //validar que todos los selects de edad tengan seleccionada una edad
        for (let room = 0; room <= this.occupancy.length - 1; room++) {
            isValid = self._validateAgesRoom(room);
        }
        return isValid;
    }
    _validateAgesRoom(roomIndex) {
        let self = this;
        let menu = self.querySelector('.searchDropdown');
        if (!menu) {
            /*If menu doesn't exist, it can't be validated, so it returns true*/
            return true;
        }
        let roomContainer = menu.querySelectorAll(".searchGroup")[roomIndex];
        let isRoomValid = true;
        if (this.occupancy[roomIndex].ages) {
            this.occupancy[roomIndex].ages.forEach(function(child){
                let age = parseInt(child, 10);
                if (isNaN(age) || age === 0) {
                    isRoomValid = false;
                }
            });
        }
        if (roomContainer) {
            if (roomContainer.querySelectorAll(".searchAddAge__select")) {
                roomContainer.querySelectorAll(".searchAddAge__select").forEach(function(select){
                    let selectVal = parseInt(select.value, 10);
                    if (selectVal === 0) {
                        self._toggleErrorClass(select, true);
                    } else {
                        self._toggleErrorClass(select, false);
                    }
                });
            }
        }
        return isRoomValid;
    }
    _discardChangesAndClose(e) {
        e.stopPropagation();
        e.preventDefault();
        this.occupancy = JSON.parse(JSON.stringify(this.occupancyCopy));
        this._countRooms();
        this._toggleMenu();
    }

    _adultsIncrement(e) {
        e.stopPropagation();
        let clickedEl = e.target;
        let roomIndex = this._getRoomIndex(clickedEl);
        this.occupancy[roomIndex].adults++;
        this.occupancy = [...this.occupancy];
    }

    _adultsDecrement(e) {
        e.stopPropagation();
        let clickedEl = e.target;
        let roomIndex = this._getRoomIndex(clickedEl);
        this.occupancy[roomIndex].adults--;
        this.occupancy = [...this.occupancy];
        this._checkChildrenPerAdult(roomIndex);
    }

    _childrenIncrement(e) {
        e.stopPropagation();
        let clickedEl = e.target;
        let roomIndex = this._getRoomIndex(clickedEl);
        let roomChangedContainer = this.querySelectorAll(".searchGroup")[roomIndex];
        this.occupancy[roomIndex].children++;
        this.occupancy[roomIndex].ages.push(this.settings.ages.def);
        this.occupancy = [...this.occupancy];
        if (this.querySelectorAll(".searchGroup.changed").length > 0) {
            this.querySelector(".searchGroup.changed").classList.remove("changed");
        }
        roomChangedContainer.classList.add("changed");
        this._validateAgesRoom(roomIndex);
    }

    _childrenDecrement(e) {
        e.stopPropagation();
        let clickedEl = e.target;
        let roomIndex = this._getRoomIndex(clickedEl);
        this.occupancy[roomIndex].children--;
        this.occupancy[roomIndex].ages.pop();
        this.occupancy = [...this.occupancy];
    }
    _toggleErrorClass(element, addError) {
        if (addError) {
            element.classList.add("has_error");
        } else {
            element.classList.remove("has_error");
        }
    }
    _ageUpdate(e) {
        let changedEl = e.target;
        let changedElVal = parseInt(changedEl.value);
        let roomIndex = this._getRoomIndex(changedEl);
        let selectIndex = Array.prototype.indexOf.call(changedEl.parentNode.children, changedEl);
        this.occupancy[roomIndex].ages[selectIndex] = changedElVal;
        this.occupancy = [...this.occupancy];
    }
    _addRoom(e) {
        e.stopPropagation();
        if (this.rooms < this.settings.rooms.max) {
            let defaultAges = [];
            while(defaultAges.length < this.settings.children.min) {
                defaultAges.push(this.settings.ages.def);
            }
            let defaultRoom = {adults: this.settings.adults.def, children: this.settings.children.def, ages: defaultAges};
            this.occupancy = [...this.occupancy, defaultRoom];
            this._countRooms();
        }
        this._evalDirectionDrop();
    }
    _removeRoom(e) {
        e.stopPropagation();
        let clickedEl = e.target;
        let roomIndex = this._getRoomIndex(clickedEl);
        this.occupancy.splice(roomIndex, 1);
        this.occupancy = [...this.occupancy];
        this._countRooms();
    }
    _checkRooms() {
        if (this.rooms == 0) {
            this.occupancy.splice(1);
            this.occupancy = [...this.occupancy];
        }
    }
    _countRooms() {
        if (this.rooms > 0) {
            this.rooms = this.occupancy.length;
        }
    }
    _checkChildrenPerAdult(roomIndex) {
        let maxRoomChildrenPerAdult = this.occupancy[roomIndex].adults * this.settings.children_per_adult;
        if (this.settings.children_per_adult !==0 && maxRoomChildrenPerAdult <= this.occupancy[roomIndex].children) {
            let childrenExcess = this.occupancy[roomIndex].children - maxRoomChildrenPerAdult;
            //dejamos el numero de ninos en el maximo de la habitacion por adulto para la nueva cantidad de adultos
            this.occupancy[roomIndex].children = maxRoomChildrenPerAdult;
            //eliminamos las edades de todos los ninos que sobren de la habitacion para la nueva cantidad de adultos
            this.occupancy[roomIndex].ages.length = maxRoomChildrenPerAdult;
            this.occupancy = [...this.occupancy];
        }
    }
    _loopAges() {
        this.childrenAges = [];
        for (let age = this.settings.ages.min; age <= this.settings.ages.max; age++) {
            this.childrenAges.push(age);
        }
    }
    _countPassengers() {
        let numPassengers = 0;
        let numAdults = 0;
        let numChildren = 0;

        numAdults = this._countAdults();
        numChildren = this._countChildren();
        numPassengers = numAdults + numChildren;
        return numPassengers;
    }
    _countAdults() {
        let numAdults = 0;
        numAdults = this.occupancy.reduce((accumulator, current) => accumulator + parseInt(current.adults), 0);
        return numAdults;
    }
    _countChildren() {
        let numChildren = 0;
        numChildren = this.occupancy.reduce((accumulator, current) => accumulator + parseInt(current.children), 0);
        return numChildren;
    }
    _getRoomIndex(targetElement) {
        let el = targetElement;
        //polyfill para .closest selector para IE11
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function(s) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }

        let room = el.closest(".searchGroup");
        let roomsContainer = room.parentNode;
        let roomIndex = Array.prototype.indexOf.call(roomsContainer.children, room);
        return roomIndex;
    }
    _focusAges() {
        if (this.querySelectorAll(".searchGroup.changed").length > 0 && this.querySelectorAll(".searchGroup.changed")[0].querySelectorAll(".searchAddAge__items").length > 0) {
            let agesSelectors = this.querySelectorAll(".searchGroup.changed")[0].querySelectorAll(".searchAddAge__items")[0].querySelectorAll(".searchAddAge__select");
           //hacer foco en el ultimo selector de edades posible de la ultima habitacion que se haya modificado su ocupacion
            let lastElementIndex = agesSelectors.length - 1;
            this.querySelectorAll(".searchGroup.changed")[0].querySelectorAll(".searchAddAge__items")[0].querySelectorAll(".searchAddAge__select")[lastElementIndex].focus();
        }
    }
    _focusRooms() {
        if (this.querySelectorAll(".searchGroup").length > 0) {
            //Hacer foco en el primer boton de subir numero de adultos en la ultima habitacion que haya
            this.querySelectorAll(".searchGroup")[this.rooms - 1].querySelector(".searchCounter__btn--plus").focus();
        }
    }

    _conditionDisableLessAdults(roomIndex) {
        return this.occupancy[roomIndex].adults <= this.settings.adults.min;
    }
    _conditionDisableMoreAdults(roomIndex) {
        let disabled = false;
        if (this.settings.max_passengers !== 0 && this.passengers >= this.settings.max_passengers) {
            disabled = true;
        } else {
            if (this.totalAdults >= this.settings.adults.max) {
                disabled = true;
            } else {
                if (this.settings.max_room_occupants !== 0 && (this.occupancy[roomIndex].adults + this.occupancy[roomIndex].children) >= this.settings.max_room_occupants) {
                    disabled = true;
                }
            }
        }
        return disabled;
    }
    _conditionDisableLessChildren(roomIndex) {
        return this.occupancy[roomIndex].children <= this.settings.children.min;
    }
    _conditionDisableMoreChildren(roomIndex) {
        let disabled = false;
        if (this.settings.max_passengers !== 0 && this.passengers >= this.settings.max_passengers) {
            disabled = true;
        } else {
            if (this.totalChildren >= this.settings.children.max) {
                disabled = true;
            } else {
                if (this.settings.max_room_occupants !== 0 && (this.occupancy[roomIndex].adults + this.occupancy[roomIndex].children) >= this.settings.max_room_occupants) {
                    disabled = true;
                } else {
                    if (this.settings.children_per_adult !==0 && (this.occupancy[roomIndex].adults * this.settings.children_per_adult) <= this.occupancy[roomIndex].children) {
                        disabled = true;
                    }
                }
            }
        }
        return disabled;
    }
    _conditionEnableAddRoom() {
        let enabled = false;
        if (this.rooms > 0) {
            if (this.settings.max_passengers !== 0 && this.passengers >= this.settings.max_passengers) {
                enabled = false;
            } else {
                if (this.rooms < this.settings.rooms.max && this.settings.rooms.min != this.settings.rooms.max) {
                    if (this.totalAdults + this.settings.adults.def <= this.settings.adults.max && this.totalChildren + this.settings.children.def <= this.settings.children.max) {
                        enabled = true;
                    }
                }
            }
        }
        return enabled;
    }

    render(){
        //se recoge el valor de settings de edad minima y maxima de children y se genera un array de edades para luego crear los desplegables de edad en el template
        this._loopAges();
        return html`
            ${this.templateToggleBtn}
            <div class="searchDropdown hidden" aria-labelledby="${this.id}-menubt">
                ${this.templateCloseLayerBtn}
                <div class="searchGroups">
                    ${this.occupancy.map((room, roomIndex) => html`
                        <div class="searchGroup">
                            ${this.rooms > 0 ? html`<div class="searchGroup__title">
                                <div class="searchGroup__titletext">${this.settings.labels.room_text} ${(roomIndex + 1)}</div>
                                ${roomIndex > 0 ? html`<button type="button" class="searchGroup__delete btn btn-link" @click="${this._removeRoom}">${this.settings.labels.delete_room_text}</button>`:``}
                            </div>` : html`` }
                            <div class="searchOption">
                                <div class="searchOption__label">${this.settings.labels.adults_text}</div>
                                <div class="searchCounter">
                                    <button type="button" class="searchCounter__btn searchCounter__btn--minus" ?disabled="${this._conditionDisableLessAdults(roomIndex)}" @click="${this._adultsDecrement}">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="icon anyfill-ui-minus" viewBox="0 0 36 36" aria-labelledby="${this.id}${roomIndex}-deleteadults">
                                            <title id="${this.id}${roomIndex}-deleteadults">-</title>
                                            <path fill="currentColor" fill-rule="evenodd" d="M20 20H4v-4h28v4z"></path>
                                        </svg>
                                    </button>
                                    <input type="text" class="searchCounter__input" readonly value="${this.occupancy[roomIndex].adults}" />
                                    <button type="button" class="searchCounter__btn searchCounter__btn--plus" ?disabled="${this._conditionDisableMoreAdults(roomIndex)}" @click="${this._adultsIncrement}">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="icon anyfill-ui-plus" viewBox="0 0 36 36" aria-labelledby="${this.id}${roomIndex}-addadults">
                                            <title id="${this.id}${roomIndex}-addadults">+</title>
                                            <path fill="currentColor" fill-rule="evenodd" d="M32 20H20v12h-4V20H4v-4h12V4h4v12h12z"></path>
                                        </svg>
                                    </button>
                                </div>
                                ${this.settings.children.max > 0 ? html`` : html`<div>${this.settings.labels.no_children_text}</div>` }
                            </div>
                            ${this.settings.children.max > 0 ? html`<div class="searchOption">
                                <div>
                                    <div class="searchOption__label">${this.settings.labels.children_text}</div>
                                    <div class="searchOption__detail">${this.settings.ages.less ? html`0` : html`${this.settings.ages.min}`}-${this.settings.ages.max} ${this.settings.labels.ages_text}</div>
                                </div>
                                <div class="searchCounter">
                                    <button type="button" class="searchCounter__btn searchCounter__btn--minus" ?disabled="${this._conditionDisableLessChildren(roomIndex)}" @click="${this._childrenDecrement}">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="icon anyfill-ui-minus" viewBox="0 0 36 36" aria-labelledby="${this.id}${roomIndex}-deletechildren">
                                            <title id="${this.id}${roomIndex}-deletchildren">-</title>
                                            <path fill="currentColor" fill-rule="evenodd" d="M20 20H4v-4h28v4z"></path>
                                        </svg>
                                    </button>
                                    <input type="text" class="searchCounter__input" readonly value="${this.occupancy[roomIndex].children}" />
                                    <button type="button" class="searchCounter__btn searchCounter__btn--plus" ?disabled="${this._conditionDisableMoreChildren(roomIndex)}" @click="${this._childrenIncrement}">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="icon anyfill-ui-plus" viewBox="0 0 36 36" aria-labelledby="${this.id}${roomIndex}-addchildren">
                                            <title id="${this.id}${roomIndex}-addchildren">+</title>
                                            <path fill="currentColor" fill-rule="evenodd" d="M32 20H20v12h-4V20H4v-4h12V4h4v12h12z"></path>
                                        </svg>
                                    </button>
                                </div>
                                ${this.occupancy[roomIndex].children >= 1 ? html` 
                                    <div class="searchAddAge">
                                        <p>${this.settings.labels.children_age_label}</p>
                                        <div class="searchAddAge__items">                      
                                           ${Array.from({ length: this.occupancy[roomIndex].children }).map((minor, minorIndex) => html`
                                                <select class="form-control searchAddAge__select" @change="${this._ageUpdate}">
                                                    <option value="0">--</option>
                                                    ${this.settings.ages.less ? html`<option value="1" ?selected="${this.occupancy[roomIndex].ages[minorIndex] === 1}">< ${this.settings.ages.min}</option>` : html``}
                                                    ${this.childrenAges.map(age => html`<option ?selected="${this.occupancy[roomIndex].ages[minorIndex] === age}" value="${age}">${age}</option>`)}
                                                </select>
                                            `)}
                                        </div>
                                        ${this._validateAgesRoom(roomIndex) ? html`` : html`<div class="searchAddAge__errors error_text">${this.settings.errors.ages}</div>`}
                                    </div>
                                ` : html``}
                            </div>` : html`` }
                        </div>
                    `)}
                </div>
                ${this.templateDropdownFooter}
            </div>
        `;
    };
    get templateToggleBtn() {
        return html`<div class="form-group">
                <label>${this.settings.labels.occupancy_label}</label>
                <button type="button" id="${this.id}-menubt" class="form-control searchToggle__btn" @click="${this._saveChangesAndToggle}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="searchToggle__txt">${this.passengers} ${this.passengers === 1 ? this.settings.labels.person_text : this.settings.labels.people_text}${this.rooms > 0 ? html`, ${this.rooms} ${this.rooms === 1 ? this.settings.labels.room_text : this.settings.labels.rooms_text }` : html``}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 36" class="searchToggle__icon icon icon-anyfill-ui-chevron-down" aria-hidden="true">
                        <path fill="currentColor" fill-rule="evenodd" d="M5.564 8.4L18 20.595 30.436 8.4 34 11.895 18 27.6 2 11.895z"></path>
                    </svg>
                </button>
            </div>`;
    };

    get templateCloseLayerBtn() {
        return html`<button type="button" class="close visible-xs" @click="${this._discardChangesAndClose}">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 36" class="icon icon-anyfill-ui-close" aria-labelledby="occupancyModalclose">
                        <title id="occupancyModalclose">${this.settings.labels.close_layer_text}</title>
                        <path fill="currentColor" fill-rule="evenodd" d="M34 5.223L30.777 2 18 14.777 5.223 2 2 5.223 14.777 18 2 30.777 5.223 34 18 21.223 30.777 34 34 30.777 21.223 18z"></path>
                    </svg>
                </button>`;
    };

    get templateDropdownFooter() {
        return html`<div class="searchDropdown__footer">
                   ${this._conditionEnableAddRoom() ? html`<button type="button" class="btn btn-link" @click="${this._addRoom}">${this.settings.labels.add_room_text}</button>` : html``} <button class="btn btn-interactive btn-transparent" @click="${this._saveChangesAndToggle}">${this.settings.labels.done_layer_text}</button>
                </div>`;
    };

}
if (!window.customElements.get('occupancy-layer')) {
    customElements.define('occupancy-layer', OccupancyLayer);
}
